import { tmrResourceFormController } from 'tmr/controllers/resourceForm/resourceForm'
import templateUrl from './form.html'

/**
 * Add Product route override
 *
 * @namespace routes.ReportProductFormAdd
 * @type {TmrRoute}
 */
let addRoute = {
  name: 'report.products.add',
  resolve: {
    productImageEnabled: /*@ngInject*/ appConfiguration =>
      appConfiguration['product.image.enabled'],
  },
}

/**
 * Edit Product route override
 *
 * @namespace routes.ReportProductFormEdit
 * @type {TmrRoute}
 */
let editRoute = {
  name: 'report.products.view.edit',
  resolve: {
    productImageEnabled: /*@ngInject*/ appConfiguration =>
      appConfiguration['product.image.enabled'],
  },
}

export const routes = [addRoute, editRoute]

/**
 * Product add/edit form component
 *
 * @type {ngComponent}
 */
export const tmrAdminProductForm = {
  ngType: 'component',
  templateUrl,
  controller: 'tmrAdminProductFormController',
  bindings: {
    resource: '<',
    toast: '<',
    productImageEnabled: '<',
  },
}

/**
 * Controller of component {@link tmrAdminProductForm}
 *
 * @type {ngController}
 */
export class tmrAdminProductFormController extends tmrResourceFormController {

  constructor(
    $scope,
    $state,
    $stateParams,
    TmrInvalidFormError,
    TmrToast,
    ItemConfiguration
  ) {
    'ngInject'
    super($scope, $state, $stateParams, TmrInvalidFormError, TmrToast)
    Object.assign(this, {
      ItemConfiguration
    })
  }

  $onInit() {
    super.$onInit()

    if (this.$stateParams.itemConfiguration) {
      this.resource.itemConfiguration = this.$stateParams.itemConfiguration
      this.itemConfigurationText = this.$stateParams.itemConfiguration.description
    }
  }

  addAttribute(attribute) {
    this.resource.attributes[attribute.key] = attribute
    this.attribute = {}
  }

  removeAttribute(key) {
    delete this.resource.attributes[key]
  }

  /** Query to get itemConfigurations for md-autocomplete */
  getItemConfigurations(value) {
    return this.ItemConfiguration.search({ value }).$promise
  }
}
